function handleChatClick() {
    const chatElement = document?.getElementById(`ShopifyChat`)?.shadowRoot?.querySelector(`.chat-app>button`)
    chatElement && chatElement.click()
}
export {handleChatClick}
